import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { LanguageSkills } from '../types/entities/LanguageSkills';
import { SelectField } from '../components/Table/fields/SelectField';
import { enumItems } from './enumItems';

export const languageSkills: SchemaWithClient<LanguageSkills> = {
  name: 'Language Skills',
  pluralName: 'Language Skills',
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      fieldType: 'text',
    },
    /* guide: {
      name: 'Guide',
      required: true,
      fieldRenderer: SelectField.tableAdapter(enumItems.guide),
      switchboard: true,
    },*/
    language: {
      name: 'Language',
      fieldRenderer: SelectField.tableAdapter(enumItems.language),
      switchboard: true,
      url: enumItems.language.client.getAllPath,
      tempSchema: enumItems.language,
    },
    level: {
      name: 'Level',
      fieldRenderer: SelectField.tableAdapter(enumItems.languageLevel),
      switchboard: true,
      url: enumItems.languageLevel.client.getAllPath,
      tempSchema: enumItems.languageLevel,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/language-skills'),
};
